import PropTypes from 'prop-types'
import { Box, Flex } from 'reflexbox/styled-components'
import styled, { css } from 'styled-components'

export const Container = styled(Box)(
  ({ theme, isOpenOnMobile, showSidebar }) => css`
    position: fixed;
    top: 0;
    left: -220px;
    bottom: 0;
    min-width: 220px;
    max-width: 220px;
    background-color: ${theme.colors.blues.A400};
    padding: 80px 24px 24px 32px;
    transition: left 0.6s ease;
    z-index: 20;

    ${isOpenOnMobile &&
      css`
        left: 0;
      `}

    ${showSidebar &&
      css`
        display: none;
      `}
      
    @media (min-width: ${theme?.breakpoints[1]}) {
      transition: none;
      position: relative;
      left: 0;
    }
  `,
)

export const ItemLabel = styled.div`
  font-size: 13.2px;
  margin-bottom: 5px;
`

Container.defaultProps = {
  isOpenOnMobile: false,
}

Container.propTypes = {
  isOpenOnMobile: PropTypes.bool,
}

export const Logo = styled.img`
  margin-bottom: 32px;
`

export const Menu = styled.ul`
  margin: 26px 0;
  padding: 0;
  list-style: none;
`

export const MenuItem = styled.li`
  margin-bottom: 10px;

  & > a {
    button {
      text-transform: uppercase;
    }
  }
`

export const NavigationDiv = styled.div`
  ${({ theme }) => css`
    text-transform: uppercase;
    display: flex;
    align-items: center;
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes.label};
    font-weight: 900;
    line-height: 16px;
    text-decoration: none;
    text-align: start;
    border: 0;
    background: transparent;
  `}
`

export const OptionsContainer = styled(Flex)`
  ${({ children, isOpen }) => css`
    max-height: ${isOpen ? children?.length * 26 || 120 : 0}px;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
  `}
`

OptionsContainer.defaultProps = {
  isOpen: false,
}
OptionsContainer.propTypes = {
  isOpen: PropTypes.bool,
}
